import React from 'react'
import List from '../../crud/list'
import menuItems from './menuItems'
import { userEmailHydrator } from '../../../fieldOptions/hydrators'
import registrationStatuses, { statusName } from '../../../fieldOptions/registrationStatuses'
import FileUploadIcon from 'material-ui/svg-icons/file/file-upload'
import { browserHistory } from 'react-router'

const columns = [
  { title: 'User', prop: 'user_id', references: 'admin/users', referenceProp: 'name' },
  { title: 'Institution', prop: 'institution_id', references: 'admin/institutions', referenceProp: 'name' },
  { title: 'Created', prop: 'created_at', format: 'dateWithDay' },
  { title: 'Updated', prop: 'updated_at', format: 'dateWithDay' },
  { title: 'Status', prop: 'status', format: statusName, sortable: true }
]

const filters = [
  {
    name: 'Filter by institution',
    prop: 'filters.institution_id',
    type: 'autocomplete',
    references: 'admin/institutions',
    referenceProp: 'name',
    enabled: true
  },
  {
    name: 'Filter by user',
    prop: 'filters.user_id',
    type: 'autocomplete',
    dataHydrator: userEmailHydrator,
    references: 'admin/users',
    referenceProp: 'fullname',
    displayProp: 'displayVal',
    enabled: true
  },
  {
    name: 'Filter by status',
    prop: 'filters.status',
    type: 'select',
    enabled: true,
    items: registrationStatuses.map(status => {
      return {
        prop: status.value,
        title: status.name
      }
    })
  }
]

const defaults = {
  order: [{ column: 'updated_at', direction: 'desc' }]
}

const SessionReservations = (props) => (
  <List
    title='Session Reservations'
    apiPath='admin/session_reservations'
    fixedFilters={{ session_sale_id: props.params.sessionSaleId }}
    filters={filters}
    columns={columns}
    defaults={defaults}
    buildMenuItems={menuItems}
    customActions={[{
      handleTap: () => browserHistory.push(`${props.location.pathname}/import`),
      icon: <FileUploadIcon />,
      title: 'Bulk Import'
    }]}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    withExport
  />
)

export default SessionReservations
